import React, { useEffect, useState } from "react";
// import axiosInstance from "../../utils/axiosApi";
import axiosInstance from "../../utils/axiosKeycloakApi";
import { useParams, useLocation } from "react-router-dom";

const PandEdit = () => {
  let { id } = useParams();

  const [plaats, setPlaats] = useState("");
  const [pandnaam, setPandnaam] = useState("");
  const [omschrijving, setOmschrijving] = useState("");
  const [adres, setAdres] = useState("");
  const [afbeeldingURL, setAfbeeldingURL] = useState("");

  const location = useLocation();

  useEffect(() => {
    setPlaats(location.state.pandDetails.plaats);
    setPandnaam(location.state.pandDetails.pandnaam);
    setOmschrijving(location.state.pandDetails.omschrijving);
    setAdres(location.state.pandDetails.adres);
    setAfbeeldingURL(location.state.pandDetails.afbeelding_url);
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      await axiosInstance.patch(`panden/${id}/`, {
        plaats: plaats,
        pandnaam: pandnaam,
        omschrijving: omschrijving,
        adres: adres,
        afbeelding_url: afbeeldingURL,
      }).then(response => {
        try{
          if(response.response.status==403){
            alert("Forbidden! You do not have permission to perform this action.");
            return (window.location = "/app/");
          } else {
            alert("Bewerking voltooid!");
            return (window.location = "/app/");
          };
        } catch(e){
          alert("Bewerking voltooid!");
          return (window.location = "/app/");
          console.log("operation seems successfull, known error",e);
        }
      });

      // return (window.location = `/app/panden/${id}/`);
    } catch (e) {
      // Verwijs gebruiker terug naar pand-detailpagina als bevoegdheden ontbreken
      return alert(
        `${e} (Mogelijk heb je een plaatsnaam ingevoerd die niet opgenomen is in de DB.)`
      );
    }
  };

  return (
    <section className="section">
      <div className="container" style={{ width: "50%" }}>
        <p className="title is-4">Bewerk gegevens voor {pandnaam}</p>
        <div className="form box">
          <div className="field">
            <label className="label">Plaatsnaam</label>
            <div className="control has-icons-left">
              <input
                name="plaats"
                className="input"
                type="text"
                placeholder="Plaatsnaam"
                defaultValue={plaats}
                onChange={(e) => setPlaats(e.target.value)}
              />
              <span className="icon is-small is-left">
                <i className="fas fa-map-pin"></i>
              </span>
            </div>
          </div>

          <div className="field">
            <label className="label">Pandnaam</label>
            <div className="control has-icons-left has-icons-right">
              <input
                name="pandnaam"
                className="input"
                type="text"
                placeholder="Pandnaam"
                defaultValue={pandnaam}
                onChange={(e) => setPandnaam(e.target.value)}
              />
              <span className="icon is-small is-left">
                <i className="fas fa-home"></i>
              </span>
            </div>
          </div>

          <div className="field">
            <label className="label">Adres</label>
            <div className="control has-icons-left has-icons-right">
              <input
                name="adres"
                className="input"
                type="text"
                placeholder="Straatnaam, huisnummer en postcode"
                defaultValue={adres}
                onChange={(e) => setAdres(e.target.value)}
              />
              <span className="icon is-small is-left">
                <i className="fas fa-envelope"></i>
              </span>
            </div>
          </div>

          <div className="field">
            <label className="label">Afbeelding URL</label>
            <div className="control has-icons-left has-icons-right">
              <input
                name="afbeelding_url"
                className="input"
                type="text"
                placeholder="Afbeelding URL"
                defaultValue={afbeeldingURL}
                onChange={(e) => setAfbeeldingURL(e.target.value)}
              />
              <span className="icon is-small is-left">
                <i className="far fa-file-image"></i>
              </span>
            </div>
          </div>

          <div className="field">
            <label className="label">Omschrijving</label>
            <div className="control">
              <textarea
                name="omschrijving"
                className="textarea"
                placeholder="Omschrijving"
                defaultValue={omschrijving}
                onChange={(e) => setOmschrijving(e.target.value)}
              ></textarea>
            </div>
          </div>

          <div className="field is-grouped">
            <div className="control">
              <button
                onClick={handleSubmit}
                className="button is-primary is-outlined is-small"
              >
                <i class="far fa-save"></i>
                <strong>Opslaan</strong>
              </button>
            </div>
            <div className="control">
              <button
                onClick={() => (window.location = `/app/panden/${id}/`)}
                className="button is-danger is-outlined is-small"
              >
                <i class="fas fa-ban"></i>
                <strong>Annuleren</strong>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PandEdit;
